import { ISsecretaria, Secretaria, SecretariaList } from '../secretaria/Secretaria';

export interface Setor {
  id: string;
  nome: string | null;
  descricao: string | null;
  endereco: string | null;
  numero: string | null;
  complemento: string | null;
  telefone: string | null;
  bairro: string | null;
  cidade: string | null;
  cep: string | null;
  secretaria: Secretaria | null;
}

export const ISsetor: Setor = {
  id: '',
  nome: '',
  descricao: '',
  endereco: '',
  numero: '',
  complemento: '',
  telefone: '',
  bairro: '',
  cidade: '',
  cep: '',
  secretaria: ISsecretaria
};

export interface SetorList {
  id: string;
  nome: string | null;
  descricao: string | null;
  secretaria: SecretariaList | null;
  excluido: boolean;
  novo: boolean;
}

export const ISsetorList: SetorList = {
  id: '',
  nome: '',
  descricao: '',
  secretaria: ISsecretaria,
  excluido: false,
  novo: false
};